export default __webpack_public_path__ + "static/media/Bullet 04.4552515a.webp";